export default {
  API_URL: 'https://api.hashsnap.net',
  MOSAIC_API_URL: 'https://api-mosaic.hashsnap.net'
};
